export const WORKSPACE_LANDING_PAGE_SHOW = 'landing_page_is_shown';
export const LANDING_PAGE_IS_SHOWN = 'landing_page_is_shown';
